module.exports = __webpack_public_path__ + "img/tooltip_05-vallone-lax-classic-white.49aa86e6.jpg";